import { Link, useLocation } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../auth/AuthContext";

const LoginGate = ({ feature, children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading)
        return (
            <div className="flex min-h-[50vh] items-center justify-center" data-testid="auth-checking">
                <div className="h-8 w-8 animate-spin rounded-full border-2 border-ink/10 border-t-saffron" />
            </div>
        );

    if (!user)
        return (
            <div className="mx-auto max-w-md px-6 py-12" data-testid="login-required">
                <div className="rounded-3xl border border-ink/5 bg-white p-10 text-center shadow-sm">
                    <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-saffron-soft">
                        <Lock className="h-6 w-6 text-saffron" />
                    </span>
                    <h2 className="mt-6 font-display text-2xl font-semibold tracking-tight text-ink">
                        Login required
                    </h2>
                    <p className="mt-3 text-sm leading-relaxed text-smoke">
                        {feature} runs on live data tied to your SahiKhoj account. Log in
                        or create a free account to continue — it takes a few seconds.
                    </p>
                    <div className="mt-7 flex flex-col gap-3">
                        <Link
                            to="/login"
                            state={{ from: location.pathname }}
                            data-testid="gate-login-button"
                            className="rounded-full bg-saffron px-8 py-3.5 text-sm font-medium text-white transition-colors hover:bg-saffron-hover"
                        >
                            Log in
                        </Link>
                        <Link
                            to="/signup"
                            state={{ from: location.pathname }}
                            data-testid="gate-signup-button"
                            className="rounded-full border border-ink/15 px-8 py-3.5 text-sm font-medium text-ink transition-colors hover:border-saffron hover:text-saffron"
                        >
                            Sign up free
                        </Link>
                    </div>
                    <p className="mt-5 text-xs text-smoke">
                        Browsing deals, coupons, brands and AI Search stays free without an account.
                    </p>
                </div>
            </div>
        );

    return children;
};

export default LoginGate;
